export const FETCH_UPDATE_PROJECT_TEMPLATE_TASK_REQUEST = 'FETCH_UPDATE_PROJECT_TEMPLATE_TASK_REQUEST'
export const FETCH_UPDATE_PROJECT_TEMPLATE_TASK_SUCCESS = 'FETCH_UPDATE_PROJECT_TEMPLATE_TASK_SUCCESS'
export const FETCH_UPDATE_PROJECT_TEMPLATE_TASK_FALUIRE = 'FETCH_UPDATE_PROJECT_TEMPLATE_TASK_FALUIRE'
